/*
===============================================================================================================
                                 Copyright 2025-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

export const getLocalAdminConfig = async ({ carrier }) => {
  let whitelabelConfig = {};
  try {
    const whitelabelConfigContent = await import(`@/public/admin-config/ADMIN_RETURNS_PORTAL_${carrier}.json`);
    whitelabelConfig = whitelabelConfigContent.default;
  } catch (error) {
    throw new Error(error.message);
  }

  return {
    data: whitelabelConfig,
  };
};

export default getLocalAdminConfig;
